/* eslint-disable */

import PersonalDetailsContent from 'components/PersonalDetails/components/content';
import GlobalContext from 'contexts';
import { useContext, useEffect, useState } from 'react';
import FormGroup from 'components/FormGroup';
import { fieldsEditMeetingDetails, fieldsEditMeasures } from './utils';
import usePostData from 'hooks/usePostData';
import { calcBMI } from 'utils';

import './styles.scss';

const EditMeasure = () => {
  const {
    currentMeeting,
    setMeasuresData,
    setCurrentMeeting,
    setOpenDrawer,
    measuresData,
    currentProduct,
    currentCustomer
  } = useContext(GlobalContext);
  const { postData, res, error } = usePostData();
  const [updatedData, setUpdatedData] = useState();
  const [errFun, setErrFun] = useState();

  useEffect(() => {
    if (error)
      errFun?.set('apiError', {
        type: 'string',
        message: error.apiError
      });
    else if (res && res.affected === 1) {
      const copyMeasures = JSON.parse(JSON.stringify(measuresData));
      console.log('ccccccc', copyMeasures);
      const newMeasuresArr = copyMeasures?.map((obj) => {
        if (obj.id === currentMeeting.id) {
          return { ...updatedData, changed: true };
        } else return obj;
      });
      setMeasuresData(newMeasuresArr);
      setCurrentMeeting(null);
      setOpenDrawer(false);
    }
  }, [res, error]);

  const handleUpdateMeeting = (data, setError) => {
    setErrFun({ set: setError });
    console.log('data', data);
    setUpdatedData({
      ...data,
      bmi: parseInt(
        calcBMI(parseInt(currentCustomer.height), parseInt(data.whight))
      )
    });
    const measureData = {
      MuscleMass: parseInt(data.MuscleMass),
      muscleStrength: parseInt(data.muscleStrength),
      bloodPressureSys: parseInt(data.bloodPressureSys),
      bloodPressureDys: parseInt(data.bloodPressureDys),
      bmi: parseInt(
        calcBMI(parseInt(currentCustomer.height), parseInt(data.whight))
      ),
      fatPct: parseInt(data.fatPct),
      flexibilityIndex: parseInt(data.flexibilityIndex),
      heartBeatRate: parseInt(data.heartBeatRate),
      whight: parseInt(data.whight),
      meetingSummery: data.meetingSummery,
      clientId: data.clientId,
      reporterId: data.reporterId,
      clientProductStageId: data.clientProductStageId,
      meetingId: data.meetingId
    };

    postData(`measure/${currentMeeting.id}`, measureData, 'post');
  };

  return (
    <div className="measures-edit">
      <PersonalDetailsContent
        fields={fieldsEditMeetingDetails}
        data={currentMeeting}
      />
      <div className="measures-area">
        <div className="measures-area-title">עדכון מדדים לפגישה</div>
        <FormGroup
          data={currentMeeting}
          fields={fieldsEditMeasures}
          onSubmit={handleUpdateMeeting}
        ></FormGroup>
      </div>
    </div>
  );
};

export default EditMeasure;

// CreateCustomer.propTypes = {
//     handleAddCustomerToOrg: PropTypes.func
// };
